import { Checkbox } from 'src/components/ui/checkbox';
import React from 'react';
import { clsx } from 'clsx';

export const CheckboxKnowledgeBasePage = ({
  item,
  checked,
  onChange = (..._args: any[]) => {},
  disabled = false,
  className = '',
}: {
  item?: any;
  checked?: any;
  onChange?: (...args: any[]) => void;
  disabled?: boolean;
  className?: string;
}) => {
  return (
    <Checkbox
      className={clsx('w-5 h-5', disabled && 'border-grey', className)}
      onDoubleClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
      checked={checked}
      onCheckedChange={(checked) => {
        onChange(checked, item);
      }}
      disabled={disabled}
    />
  );
};
